// extracted by mini-css-extract-plugin
module.exports = {"HireSignup":"style_HireSignup__3Ny8e","logo":"style_logo__25nx-","welcome":"style_welcome__3Qea0","form":"style_form__J37uT","footer":"style_footer__3HL77"};